module.exports = __webpack_public_path__ + "images/signup/envelope.442c1533.svg";